import { render, staticRenderFns } from "./TopAgentsTable.vue?vue&type=template&id=235d1b34&scoped=true&"
import script from "./TopAgentsTable.vue?vue&type=script&lang=js&"
export * from "./TopAgentsTable.vue?vue&type=script&lang=js&"
import style0 from "./TopAgentsTable.vue?vue&type=style&index=0&id=235d1b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d1b34",
  null
  
)

export default component.exports